import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../../animations/animations';
import { MdSchool, MdLocationOn, MdCalendarToday, MdGrade } from 'react-icons/md';

const Education = () => {
  return (
    <section id="education" className="py-24 px-6 bg-darkSurface/30">
      <div className="max-w-4xl mx-auto">
        <motion.h2
          variants={fadeInUp}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true }}
          className="section-header"
        >
          Education
        </motion.h2>

        <motion.div
          variants={fadeInUp}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true }}
          className="card"
          data-aos="fade-up"
        >
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
            {/* Left side - Institution info */}
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary to-primaryLight flex items-center justify-center">
                  <MdSchool className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white">
                    BMS Institute of Technology and Management
                  </h3>
                  <p className="text-primaryLight font-medium">
                    B.E, Electrical and Electronics Engineering
                  </p>
                </div>
              </div>

              <div className="flex flex-wrap gap-4 mt-4 text-textSecondary">
                <span className="flex items-center gap-2">
                  <MdLocationOn className="text-primaryLight" />
                  Bengaluru, India
                </span>
                <span className="flex items-center gap-2">
                  <MdCalendarToday className="text-primaryLight" />
                  May 2019 – May 2023
                </span>
              </div>
            </div>

            {/* Right side - CGPA */}
            <div className="flex items-center gap-3 px-6 py-4 bg-primary/10 rounded-xl border border-primary/30">
              <MdGrade className="w-8 h-8 text-primary" />
              <div>
                <p className="text-sm text-textSecondary">CGPA</p>
                <p className="text-2xl font-bold gradient-text">7.63</p>
              </div>
            </div>
          </div>

          {/* Decorative gradient line */}
          <div className="mt-6 h-1 w-full bg-gradient-to-r from-primary via-primaryLight to-transparent rounded-full opacity-30" />
        </motion.div>
      </div>
    </section>
  );
};

export default Education;
